import React from 'react';
import PropTypes from 'prop-types';
import './index.scss';

const Section = (props) => {
  const { children } = props;
  return(
    <div className="ma__section-wrapper">{children}</div>
  );
};

Section.propTypes = {
  children: PropTypes.oneOfType([PropTypes.array, PropTypes.object])
};

export default Section;
